export const DESCARGO_UNO_A_UNO = "DESCARGO_UNO_A_UNO";
export const DESCARGO_POR_LISTA_MATERIALES = "DESCARGO_POR_LISTA_MATERIALES";

/**
 * Objeto de estado global para la descarga
 */
export const DescargaCommonGlobal = {
    /**
     * Para controlar el proceso de descarga
     */
    enProceso: false,

    /**
     * Para controlar la fecha de inicio al cambiar el calendario
     */
    fechaInicio: moment().format("YYYY-MM-DD"),

    /**
     * Para controlar la fecha fin al cambiar el calendario
     */
    fechaFin: moment().format("YYYY-MM-DD"),

    /**
     * Contenedores de importación disponibles para descargar
     */
    contenedoresImportacionParaDescargar: [],

    /**
     * Contenedores de importación validados de acuerdo al pedimento de exportación
     * y mercancia seleccionada
     */
    contenedoresImportacionValidadosParaDescarga: [],

    /**
     * Pedimentos de exportación con numero de parte asignado
     */
    pedimentosExportacionValidos: {},

    /**
     * Objeto para controlar la descarga por lista de materiales
     */
    enDescarga: {
        /**
         * Bandera para controlar los materiales a mostrar en dataTableDetalle
         * Muestra materiales reales (mercancías/contenedores) o materiales de listas
         */
        tipo: DESCARGO_UNO_A_UNO,

        /**
         * Id del pedimento seleccionado para descargar
         */
        pedimentoId: null,

        /**
         * Controla cual de los materiales padre se encuentra en proceso de descarga
         */
        padreId: null,

        /**
         * Controla cual de los materiales hijo se encuentra en proceso de descarga
         */
        hijoId: null,

        /**
         * Lista de materiales a recorrer, al iniciar, estos seran los contenedores
         * en cada anidación los hijos pasaran a ser los padres, así por cada iteración
         */
        materialesPadre: [],
    },
};
